export const getWarehouseFacilityHeader = (): Record<string, string> => {
	try {
		const facilityId = useFacilityStore().getSelectedFacility?.id
		return facilityId !== null && facilityId !== undefined ? { 'X-Facility': String(facilityId) } : {}
	} catch {
		return {}
	}
}
